import Vue from "vue";
import Vuex from "vuex";
import VueI18n from "@/i18n";
import AppEnv from "./core/AppEnv";
import { Models, Interfaces, apiService } from "./core/Export";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appEnv: new AppEnv(),
    tRequestModel: {},
    fileList: [],
    residentData: {},
    systemData: {},
    callLogs: [],
    authorityName:{}
  },
  mutations: {
    updateTRequestModel(state, data) {
      state.tRequestModel = data;
    },
    updateFileList(state, data) {
      state.fileList = data;
    },
    updateResidentData(state, data) {
      state.residentData = data;
    },
    updateSystemData(state, data) {
      state.systemData = data;
      state.systemData["years"] = Object.values(state.systemData["yearsIdsPair"]);
    },
    updateCallLogs(state, data) {
      state.callLogs = data;
    },
    updateAuthorityName(state, data) {
      state.appEnv.authority = data;
    }
  },
  actions: {
    getSystemData() {
      this.state.appEnv.isBusy = true;
      this.state.appEnv.isSystemDataReady = false;
      apiService
        .getSystemData("General/GetSystemData",this.state.appEnv.authority)
        .then(res => {
          let response = res as Interfaces.ICallResult;
          if (response && response.isSuccess) {
            this.commit("updateSystemData", response.result);
            document.title = `אישור תושב ${response.result["systemSettings"]["authorityName"]}`;
            this.state.appEnv.isSystemDataReady = true;
          } else {
            this.state.appEnv.showErrorDialog(response.msgs.errors);
          }
          this.state.appEnv.isBusy = false;
        })
        .catch(err => {
          this.state.appEnv.isBusy = false;
        });
    }
  },
  getters: {
    appEnv(state) {
      return state.appEnv;
    },
    authority(state) {
      return state.appEnv;
    },
    tRequestModel(state) {
      return state.tRequestModel;
    },
    fileList(state) {
      return state.fileList;
    },
    residentData(state) {
      return state.residentData;
    },
    systemData(state) {
      return state.systemData;
    },
    callLogs(state) {
      return state.callLogs;
    }
  }
});
